import AreaContainer from "../AreaContainer";
import styles from './downloads.module.css';
import globalStyles from '../result.module.css';
import DownloadsDisplay from "./DownloadsDisplay";

interface Props {
  downloads: download[];
  id: number,
  type: string,
  britishLandLayout: boolean
}

type download = {
  format: {
    original: {
      uri: string,
      file_type: string
    }
  },
  resource_type: string,
  title: string,
}

const Downloads = ({downloads, id, type, britishLandLayout = false}: Props) => {

  if (!downloads || downloads.length === 0) return null;

  let DEFS = {
    availability: "Availability",
    brochure: "Brochure",
    documents: "Documents",
    epc_brochure: "EPC Brochure",
    floor_plan: "Floor Plan",
    goad_plan: "Goad Plan",
    sales_brochure: "Sales Brochure",
    site_plan: "Site Plan",
    space_plan: "Space Plan",
    asbestos_report: "Asbestos Report",
    lease_document: "Lease Document"
  };

  return (
    <AreaContainer area="downloads" style={null} extraClass={null}>
      <div className={britishLandLayout ? `${styles.britishLandLayout} ${styles.DownloadsWrapper}` : styles.DownloadsWrapper}>
        <h2 className={globalStyles.subTitleText}>Downloads</h2>
        <div className={ britishLandLayout ? `${styles.britishLandLayoutDownloadButtons} ${styles.downloadButtons}`: styles.downloadButtons}>
          {downloads.map((download, i) => {
            if (!download.format?.original?.uri) {
              return null;
            }
            return (
              <DownloadsDisplay key={i} uri={download.format.original.uri}
                resource_type={download.resource_type} title={download.title}
                file_type={download.format.original.file_type} altTag={DEFS[download.resource_type]} id={id} type={type}/>
            );
          })}
        </div>
      </div>
    </AreaContainer>
  );
};

export default Downloads;
